import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import {
	Wrapper,
	Overflower,
	Item,
	ShareAndLike,
} from './navigationStyles';

import { FavoriteButton, Share } from 'listing/components';
import { ResponsiveCheck } from 'core/providers/Responsive';

class Navigation extends Component {
	state = {
		offset: 0
	}

	wrapper = createRef()

	componentDidMount () {
		if (! this.wrapper.current) return;

		this.setState({
			offset: this.wrapper.current.offsetHeight
		});
	}

	render () {
		const {
			links,
			shareUrl,
			listingId,
			customerId,
			noLikes,
			onWishlistSuccess,
			style,
			isSticky,
			triggerLoginModal,
		} = this.props;
		const { offset } = this.state;
		return (
			<ResponsiveCheck>{({ isDesktop }) => (
				<Wrapper style={style} ref={this.wrapper} isSticky={isSticky}>
					<Overflower>
						{links && links.map((link, id) =>
							<Item
								key={id}
								to={link.url}
								smooth="easeInOutQuad"
								spy
								offset={offset * -1}
								activeClass="is-current">
								{link.name}
							</Item>
						)}
					</Overflower>
					<ShareAndLike>
						<Share url={shareUrl} />
						{!noLikes &&
						<FavoriteButton
							listingId={listingId}
							customerId={customerId}
							triggerLogin={triggerLoginModal}
						/>
						}
					</ShareAndLike>
				</Wrapper>
			)}</ResponsiveCheck>
		);
	}
}

Navigation.propTypes = {
	listingId: PropTypes.number,
	links: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
	})).isRequired,
	shareUrl: PropTypes.string,
	customerId: PropTypes.number,
	noLikes: PropTypes.bool,
	onWishlistSuccess: PropTypes.func,
	/* via NavigationWithHoc */
	style: PropTypes.object,
	isSticky: PropTypes.bool,
	triggerLoginModal: PropTypes.func,
};

Navigation.defaultProps = {
	onWishlistSuccess: () => null,
	style: {},
	isSticky: false,
	triggerLoginModal: () => null,
};

export default Navigation;
